<template>
  <div>
    <div class="base-input ovf-hd" style="margin-bottom: 20px; margin-top:20px;">
      <el-row class="search-title">
        <el-col :span="4" class="search-nav-left">
          <i class="el-icon-search" style="color: #4882ff;font-size: 18px;font-weight: bold;margin-left: 10px"></i>
          <span class="order-list-search-span" style="margin-left: 6px">筛选查询</span>
        </el-col>
        <el-col :span="20" class="search-nav-right">
          <el-button class="fold-button el-icon-arrow-up" type="text" @click="hide=!hide" v-show="hide"> {{ hide? '收起查询':'展开查询' }}</el-button>
          <el-button class="fold-button el-icon-arrow-down" type="text" @click="hide=!hide" v-show="!hide">{{ hide? '收起查询':'展开查询' }}</el-button>
        </el-col>
      </el-row>
        <el-collapse-transition>
          <div v-show="hide" class="search-flod-content">
            <div class="demo-input-suffix" style="text-align: left;">
              公众号切换：
              <el-select v-model="value" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
        </el-collapse-transition>
    </div>
    <el-row class="search-title">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="color: #4882ff;font-size: 18px;font-weight: bold;margin-left: 10px"></i>
        <span class="order-list-search-span" style="margin-left: 6px">数据列表</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
          <el-button type="primary" class="add-btn" style="float: right;">关闭微信人工客服</el-button>
        <router-link to="/home/artificial-service-add">
          <el-button type="primary" class="add-btn" style="float: right;margin-right:10px;">添加客服</el-button>
        </router-link>
      </el-col>
    </el-row>
    <el-row class="import-data-title">
      <el-table
      border
      :data="tableData"
      style="width: 100%">
        <el-table-column
          prop="date"
          label="工号">
        </el-table-column>
        <el-table-column
          prop="name"
          label="登陆名@token">
        </el-table-column>
        <el-table-column
          prop="name"
          label="客服昵称">
        </el-table-column>
        <el-table-column
          prop="name"
          label="在线状态">
        </el-table-column>
        <el-table-column
          prop="name"
          label="最大自动接入数">
        </el-table-column>
        <el-table-column
          prop="name"
          label="正在接待的会话数">
        </el-table-column>
        <el-table-column
          label="操作">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="编辑" placement="bottom">
              <div class="op-link">
                <i class="iconfont icon-icon-bianji" style="font-size: 14px"></i>
              </div>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
              <div class="op-link">
                <i class="iconfont icon-icon-shanchu" style="font-size: 14px"></i>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
  </div>
</template>

<script>
// import {  } from '@/api/customer.js'
export default {
  name: 'publicNumber',
  data () {
    return {
      hide: true,
      tableData: [{
        name: '21'
      }],
      options: [{
        value: '选项1',
        label: '黄金糕'
      }, {
        value: '选项2',
        label: '双皮奶'
      }, {
        value: '选项3',
        label: '蚵仔煎'
      }, {
        value: '选项4',
        label: '龙须面'
      }, {
        value: '选项5',
        label: '北京烤鸭'
      }],
      value: ''
    }
  },
  mounted () {
  },
  methods: {
  },
  created() {
  }
}
</script>

<style scoped>
.sign-manage-title {
  background: #ecf6ff;
  border: 1px solid #E4e4e4;
  height:60px;
  padding:10px;
  line-height: 40px;
  margin-top: 10px;
}
.green{
  color: green;
}
.red{
  color: red;
}
.add-btn{
  height: 30px;
  padding: 0 10px;
  border-radius: 20px;
  text-align: center;
  line-height: 30px;
  float: right;
  color: #fff;
  font-size: 14px;
  background: #4882ff;
  margin-top: 5px;
  cursor: pointer;
}
.table-title {
  text-align: left;
}
.dialog-content {
  height: 200px;
}
.content-one span {
  display: inline-block;
  float: left;
  line-height: 20px;
  font-size: 16px;
  margin-top: 10px;
}
.content-one p {
  text-align: left;
}
</style>
